// extracted by mini-css-extract-plugin
export default {"menu":"style_menu__6HGIz","menuTitle":"style_menuTitle__gSeRf","title":"style_title__lwuT-","body":"style_body__upEc9","badge":"style_badge__I-0wE"};